import { useQuery } from '@apollo/client';
import { graphql } from '@app/graphql/types';

export const QUERY = graphql(`
  query getAvailableHappyHourByBranch($branchId: ID!) {
    getAvailableHappyHourByBranch(branchId: $branchId) {
      id
      deliveryType
      discountType
      discountAmount
      minimumOrderAmount
      isActive

      timeRule {
        __typename
        ... on MenuSectionAlwaysTimeRule {
          type
        }

        __typename
        ... on MenuSectionRangeTimeRule {
          type
          start
          end
          daysOfWeek
          isAllDays
        }
      }
    }
  }
`);

export function useGetAvailableHappyHour(branchId: string) {
  return useQuery(QUERY, {
    variables: {
      branchId,
    },
  });
}
